var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServiceAppMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,2C11.8691406,2,2,11.8691406,2,24s9.8691406,22,22,22s22-9.8691406,22-22S36.1308594,2,24,2z M31,18 c0.5517578,0,1,0.4482422,1,1v10c0,0.5517578-0.4482422,1-1,1H17c-0.5517578,0-1-0.4482422-1-1V19c0-0.5517578,0.4482422-1,1-1H31z  M25,43.9493408V32h6c1.6542969,0,3-1.3457031,3-3V19c0-1.6542969-1.3457031-3-3-3h-1V8h-2v8h-8V8h-2v8h-1 c-1.6542969,0-3,1.3457031-3,3v10c0,1.6542969,1.3457031,3,3,3h6v11.9493408C12.437561,43.4232178,4,34.6907959,4,24 C4,12.9716797,12.9716797,4,24,4s20,8.9716797,20,20C44,34.6907959,35.562439,43.4232178,25,43.9493408z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceAppMedium);
export default __webpack_public_path__ + "static/media/service-app--medium.0e2b3fc96deba0621f05d5ca8fb7600f.svg";
export { ForwardRef as ReactComponent };